/* eslint-disable react/no-array-index-key */
/* eslint-disable  react/forbid-prop-types */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import '../../hotels/booking-details/BookingsList.scss';
import AppTextInput from '../../../shared/components/app-text-input/AppTextInput';
import BusBookingListCard from './BusBookingListCard';
import { debounce } from '../../../api/apiUtils';

function BookingsList({ busBookings }) {
  const [searchText, setSearchText] = useState('');
  const [transactionsList, setTransactionsList] = useState([]);
  useEffect(() => {
    setTransactionsList(busBookings);
  }, [busBookings]);

  const setSearchResults = debounce((val) => {
    let data = [...busBookings];
    if (val !== '') {
      data = data.filter((o) =>
        Object.keys(o).some(
          (k) =>
            o[k] !== null &&
            o[k] !== undefined &&
            o[k].toString().toLowerCase().includes(val.toLowerCase()),
        ),
      );
    }
    setTransactionsList(data);
  }, 500);

  const handleSearch = (event) => {
    const { value } = event.target;
    setSearchText(value);
    setSearchResults(value);
  };

  return (
    <section className="booking-list-page">
      <div className="train-search-container">
        <div className=" d-flex justify-content-end">
          <div style={{ width: '300px' }}>
            <AppTextInput
              value={searchText}
              label="search"
              onChange={handleSearch}
            />
          </div>
        </div>
      </div>

      <div className="booking-list-page__body">
        {/* {searchResults.length > 0 ? ( */}
        <div className="pt-2">
          {transactionsList.map((booking, index) => (
            <BusBookingListCard key={index} bookingData={booking} />
          ))}
        </div>
        {/* ) : (
          <NoSearchResults />
        )} */}
      </div>
      {/* )} */}
    </section>
  );
}

BookingsList.defaultProps = {};

BookingsList.propTypes = {
  busBookings: PropTypes.array.isRequired,
};

export default BookingsList;
